import { render, staticRenderFns } from "./index_grid.vue?vue&type=template&id=4b4579ad&scoped=true&"
import script from "./index_grid.vue?vue&type=script&lang=js&"
export * from "./index_grid.vue?vue&type=script&lang=js&"
import style0 from "./index_grid.vue?vue&type=style&index=0&id=4b4579ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4579ad",
  null
  
)

export default component.exports